'use client';

import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import './StepTransition.scss';

const slideToLeft = {
  initial: { x: 20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      ease: 'easeInOut',
      duration: 0.75,
    },
  },
  transition: { ease: 'easeInOut', duration: 0.75 },
};

interface StepTransitionProps {
  children?: ReactNode;
}

const StepTransition = ({ children }: StepTransitionProps) => {
  const pathname = usePathname();

  return (
    <motion.div className='step-transition' key={pathname} {...slideToLeft}>
      {children}
    </motion.div>
  );
};

export default StepTransition;
